var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BackButton } from "./Button";
import Heading from "./Heading";
import Partners, { PartnerType } from "./Partners";
import Text from "./Text";
import { Col, Grid, Row } from "./grid";
import { useTheme } from "../hooks";
import React from 'react';
import Sticky from 'react-stickynode';
import { css, mq, styled } from "../utils";
var backgroundImageStyles = function (backgroundImage) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: url('", "') no-repeat center center;\n    background-size: cover;\n  }\n\n  & > div {\n    position: relative;\n  }\n"], ["\n  position: relative;\n\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: url('", "') no-repeat center center;\n    background-size: cover;\n  }\n\n  & > div {\n    position: relative;\n  }\n"])), backgroundImage); };
var StyledSection = styled.section(function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: 1rem;\n    background-color: ", ";\n    ", "\n  "], ["\n    padding-bottom: 1rem;\n    background-color: ", ";\n    ", "\n  "])), backgroundColor, backgroundImage && backgroundImageStyles(backgroundImage));
});
var StyledSectionHeader = styled.div(mq({
    marginBottom: ['1rem', '2rem'],
}));
var StyledStickyHeader = styled(Sticky)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n\n  & > div {\n    flex: 1;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n\n  & > div {\n    flex: 1;\n  }\n"])));
var StyledHeading = styled(Heading.Heading1)(function (_a) {
    var status = _a.status, headings = _a.theme.components.headings;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    && {\n      transition: font-size 0.4s, padding 0.4s, height 0.4s;\n      ", "\n    }\n  "], ["\n    && {\n      transition: font-size 0.4s, padding 0.4s, height 0.4s;\n      ",
        "\n    }\n  "])), mq({
        fontSize: headings[status === Sticky.STATUS_ORIGINAL ? 'h1' : 'h2'].fontSize,
        paddingBottom: status === Sticky.STATUS_ORIGINAL ? 0 : '0.5rem',
    }));
});
var Section = function (_a) {
    var backgroundColor = _a.backgroundColor, backgroundImage = _a.backgroundImage, children = _a.children, description = _a.description, title = _a.title, meta = _a.meta, partners = _a.partners, onGoBack = _a.onGoBack, goBackLabel = _a.goBackLabel, className = _a.className, id = _a.id, props = __rest(_a, ["backgroundColor", "backgroundImage", "children", "description", "title", "meta", "partners", "onGoBack", "goBackLabel", "className", "id"]);
    var colors = useTheme().colors;
    return (React.createElement(StyledSection, __assign({ "data-component": "Section", id: id, className: className, backgroundColor: backgroundColor || colors.backgroundPrimary, backgroundImage: backgroundImage }, props),
        React.createElement(StyledSectionHeader, null,
            React.createElement(StyledStickyHeader, { top: "#section-sticky-header", innerZ: 10 }, function (_a) {
                var status = _a.status;
                return (React.createElement(Grid, { pt: [0, 0, '0.5rem'], backgroundColor: backgroundColor || colors.backgroundPrimary },
                    onGoBack && (React.createElement(BackButton, { label: goBackLabel, onClick: onGoBack, pt: 2, pl: 1, pb: 1 })),
                    title && (React.createElement(Row, { pt: onGoBack ? 0 : 2, px: 1 },
                        React.createElement(StyledHeading, { status: status }, title)))));
            }),
            (description || meta || partners) && (React.createElement(Grid, { backgroundColor: "transparent" },
                React.createElement(Row, { justifyContent: "space-between", flexWrap: ['wrap', 'wrap', 'nowrap'], mt: 2 },
                    React.createElement(Col, { width: [1, 1, 3 / 4] },
                        React.createElement(Text, { color: colors.lighterBlack, m: 0 }, description)),
                    React.createElement(Col, { width: [0, 0, 1 / 4], display: ['none', 'none', 'block'] }, meta ? (React.createElement(Text, { color: colors.lighterBlack, textAlign: "right", m: 0 }, meta)) : (partners && React.createElement(Partners, { partners: partners, justifyContent: "flex-end" }))))))),
        children));
};
export default Section;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Section.js.map